module.exports = __webpack_public_path__ + "733c0615c94de192e91c4ff9464c23c7.svg";